var MessageTcc = {
  NavabarText: {
    navbar_home: "主頁",
    navbar_about: "關於我們",    
    navbar_product:"產品中心",
    navbar_case: "案例中心",
    navbar_contact: "聯絡我們",
    navbar_item: "服務支持",
    navbr_new: '最新消息',
    
    navbr_join:'加入我們'

  },
  About_Navbar: {
    Company: '公司簡介',
    Horor: '榮譽與資質',
    Technology: '科研技術',
    Team: '我們的團隊 ',
  },
  New_NavBar: {
    Notice: '公司通告',
    MediaCentre: '媒體中心',
  },
  indexText: {
    more: "了解更多",
    home_title:"提供定制深度互聯網",
    home_title_1:"解決方案",
    web_build:"網站建設",
    phone_build:"手機網站",
    min_build:"小程式定制",
    share_build:"公眾號定制",

    content_title_1:'PC建站',

    content_title_content_1:'專注行銷型、會SEO的網站',

    content_title_description_1:"海量高顏值設計範本+自我調整，支持全屏DIY",

    content_title_description_1_1:"更專業SEO優化、Sitenam支持、保證百度收錄",

    content_title_description_1_2:"更有多語言、大數據，員工子帳號等你來撩",

    content_title_2:"精美型定制網站",

    content_title_content_2:"簡單、易用的企業展示到店版+預約版",

    content_title_description_2:"對企業、客戶、市場進行專業的分析，為企業建設官方形象網站。",

    content_title_description_2_1:"適用於中小規模或初創型企業，以展示產品、介紹服務為主。",

    content_title_3:"行銷型定制網站",

    content_title_content_3:"專注行銷型、會SEO的網站",

    content_title_description_3:"海量高顏值設計範本+自我調整，支持全屏DIY",

    content_title_description_3_1:"更專業SEO優化、Sitenam支持、保證百度收錄",

    content_title_description_3_2:"更有多語言、大數據，員工子帳號等你來撩",

    content_title_4:"官網小程式",

    content_title_content_4:"簡單、易用的企業展示到店版+預約版",

    content_title_description_4:"一次搞定小程式商城+微商城+電腦商城",

    content_title_description_4_1:"多終端覆蓋，1000+全行業範本不斷更新，個性化裝修，優秀設計器",

    content_title_description_4_2:"全方位管理商品，訂單，會員，數據，多種行銷功能引爆銷量",

    give_function:"提供全行業專業的解決方案",

    consulting_service:"更多行業可諮詢我們的客服",

  },
  footText: {
    companys: '廣州市優科易網絡科技有限公司',
    address: "地址:廣州市白雲區大源東寶街4號 101鋪",
    addresss: '廣州市白雲區大源東寶街4號, 101鋪',
    phone: "電話:(+86) ",
    email: "電郵:",
    weixin: "掃碼關注公眾號",
    aboutUs: '關於我們',
    company: '公司簡介',
    honor: '榮譽與資質',
    technology: '科研技術',
    team: '我們的團隊 ',
    services: '服務項目',
    news: '最新消息',
    notice: '公司通告',
    mediaCentre: '媒體中心',
    report: '查詢報告',
    contact: '聯絡我們',
    talentRecruitment: '人才招聘',
    OfficeHours: '營業時間',
    day1: '星期一至五',
    day2: '星期六至日',
    version: '版權所有 © 廣州市優科易網絡科技有限公司 2021-2022',
    back: '返回首頁',
  },
  
  ContractText:{
    termsofuse:'版權所有 © 廣州市優科易網絡科技有限公司 2021-2022',
  },
  HomeText: {
   
  },
  AboutUs: {
    h_c: '關於我們',
    j_t_1:'廣州優科易網絡科技有限公司以下簡稱：優易科，優易科是一家助力中小企業數位化經營陞級的企業，公司擁有豐富項目經驗的專案經理、專業介面設計師、互動設計師以及程式工程師。 優易科提出 "做客戶易懂的網絡" 的口號。 優易科提出 "讓網絡更簡單" 的口號。',
    j_t_2:'我們為客戶提供專業的定制網路建設服務。 服務專案涵蓋了網頁視覺設計、VI標誌設計、網站程式開發、HTML5響應式網站建設、手機網站開發、微商城、小程式開發、網站託管及維護、WEB系統開發、功能變數名稱註冊、國內外伺服器租用、視頻、平面設計、SEO優化排名等。 幫助企業更容易的獲取用戶流量，為企業提升產品和創造價值提供最堅實的支撐。'
    
   
  },
  concat: {
    h_t: '聯絡我們',
    form_t: '期望與您聯繫',
    ph_1: '給我們意見',
    name: '請輸入您的名字',
    phone:'請輸入您的電話',
    need:'請輸入您的需求',
    codemsg:'請輸入驗證碼',
    ph_3: '電話',
    ph_4: '郵箱',
    sub_t: '提交',
    location: '廣州市白雲區大源東寶街4號, 101鋪'
  },
  product:{

    type:'建站類型',
    type_title_1:'優科易管理系統',
    type_content_1:'功能强大、資料安全',
    type_title_2:'優科易商城',
    type_content_2:'一站式全包服務器名',
    type_title_3:'電腦版商城',
    type_content_3:'全站關鍵字行銷設定',
    type_title_4:'手機商城',
    type_content_4:'海量模塊線上拖拽佈局',
    type_title_5:'微信版商城',
    type_content_5:'海量模塊線上拖拽佈局',
    type_title_6:'小程式版商城',
    type_content_6:'海量模塊線上拖拽佈局',
    register:'立即注册',
    learMore:'瞭解更多',

    mall_title:'PC商城',
    mall_content_title_1:'視覺化編輯',
    mall_content_descript_1:'頁面中所有的模塊隨意拖拽、編輯，所看即所得',
    mall_content_title_2:'海量商城範本',
    mall_content_descript_2:'PC端/移動端擁有海量商城範本，輕鬆打造“與眾不同”的商城外觀',
    mall_content_title_3:'移動端分類範本',
    mall_content_descript_3:'多種移動端分類範本，幫助顧客更容易找到所需商品',
    mall_content_title_4:'自定義頁面',
    mall_content_descript_4:'製作自定義頁面，可用於新品或促銷專題，新增顧客體驗',

    },
  
  case:{
    case_title:'相關案例',
    case_descript:'我們助您擁抱互聯網新零售、新行銷',
    
    case_title_1:'香港醫務檢測中心',
    case_descript_1:'專業、全面的一站式基因檢測服務',

    case_title_2:'香港卓信醫療化驗所',
    case_descript_2:'更高質素、更方便的基因檢測科技',

    case_title_3:'香港萬利分子檢驗中心',
    case_descript_3:'專業、準確、可靠的基因檢測服務',

    case_title_4:'香港卓信醫療化驗所',
    case_descript_4:'更高質素、更方便的基因檢測科技',

    case_title_5:'報告系統',
    case_descript_5:'香港卓信醫療化驗所報告系統',

    case_title_6:'工作系統',
    case_descript_6:'香港化驗所有限公司工作系統',

    case_title_7:'友易家',
    case_descript_7:'友易家業主 友易家用戶',

    case_title_8:'善食商城',
    case_descript_8:'致力打造最專業的社區生鮮服務平臺',

    port_type:'pc端',
    port_type_1:'app',
    port_type_2:'小程序',
  },

  services:{

    type:'服務理念',
    
    type_content:'優易科從策劃、設計、前端開發、測試、驗收、上線、運維指導我們精心做好每一步。',
    
    process:'服務流程',
    
    process_item_1_title:'規範的前期溝通',
    
    process_item_1_content:'根據您的需求我們將在三個工作日內為您做一份詳盡的調研問卷、基本架構與報價，有助於一個項目的開始。',
    
    process_item_2_title:'介面設計風格',
    
    process_item_2_content:'我們擅長用心洞悉您企業及產品的內在，並用功能與美感兼顧的表現使其呈現於外，為您提供與視覺設計有關的一切。',
    
    process_item_3_title:'前端架構+後臺開發',
    
    process_item_3_content:'開發團隊遵循和約定的程式碼書寫規範，提高程式碼的規範性和可維護性，規範編碼便於日後功能拓展，减少系統維護成本。',
    
    process_item_4_title:'測試驗收',
    
    process_item_4_content:'根據頁面和需求進行程式的開發及前後端頁面的綜合測試，項目完成後，客戶可在我們提供測試網址上進行驗收。',
    
    center:'服務中心',
    
    center_1_title:'提供“7x12小時”客服熱線電話服務和“7x8小時”技術支援服務。',
    
    center_2_title:'收到技術支援需求第一時間為使用者服務，保證服務時效性。',
    
    center_3_title:'定期跟踪專案進度以保證項目高質、高效完成。',
    
    center_4_title:'售後主動回訪，隨時瞭解產品使用情况及建議不斷改進提升。',
    
    },

  notices: {
    h_t: "公司通告"
  },
};
export {
  MessageTcc
}



// WEBPACK FOOTER //
// ./src/i18n/lang/tcc.js